'use client';

// #region IMPORT
import { useState, useEffect } from 'react';

import { MainLayout } from 'src/layouts/main';

import { SplashScreen } from 'src/components/loading-screen';

import { LandingPageView } from './landing-page-view';
// #endregion
export function LandingView() {
  const [isLoading, setIsLoading] = useState(true);

  // dùng useEffect để làm mốc khi tất cả đã render xong
  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <>
      {isLoading ? (
        <SplashScreen />
      ) : (
        <MainLayout>
          <LandingPageView />
        </MainLayout>
      )}
    </>
  );
}
